import styled from 'styled-components';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const Item = styled.li<{ parentWidth?: number }>`
  list-style: none;
  margin: 0;
  padding: 0;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minXs) {
      return `height: 48px;`;
    }
    return '';
  }}
`;
